import { UserCancellationInterceptOutcomeInterface } from "@vendor-app/domain/UserCancellationInterceptOutcomeInterface";
import { UserCancellationInterceptOutcomesMapper } from "@vendor-app/mappers/UserCancellationInterceptOutcomes/mapper";

import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

export interface IPaginatedUserCancellationInterceptOutcomes {
  data: UserCancellationInterceptOutcomeInterface[];
  pageNumber: number;
  totalPages: number;
}

export default class UserCancellationInterceptOutcomesGateway {
  constructor(private readonly mapper: UserCancellationInterceptOutcomesMapper) {
    this.mapper = mapper;
  }

  public async fetch(
    pageNumber: number,
    pageSize: number,
    dateRange: { start: Date; end: Date }
  ): Promise<IPaginatedUserCancellationInterceptOutcomes> {
    let result: IPaginatedUserCancellationInterceptOutcomes = { data: [], pageNumber, totalPages: 0 };

    const incrementedEndDate = new Date(dateRange.end);
    incrementedEndDate.setDate(incrementedEndDate.getDate() + 1);

    try {
      const response = await typedFrontendVendorApi.getReq("/user-cancellation-intercept-outcomes", {
        query: {
          pageNumber: String(pageNumber),
          pageSize: String(pageSize),
          startDate: dateRange.start.toISOString(),
          endDate: incrementedEndDate.toISOString(),
        },
      });

      if (response.type === "success") {
        result = {
          data: this.mapper.mapData(response.body.data),
          pageNumber: response.body.pageNumber,
          totalPages: response.body.totalPages,
        };
      }
    } catch (error) {
      console.error("Failed to fetch user cancellation intercept outcomes:", error);
    }

    return result;
  }
}
